/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetCatastralUnitsFilterParameter { 
    /**
     * The code of the catastral unit. Partial match.
     */
    code?: string;
    /**
     * The name of the municipality. Partial match.
     */
    name?: string;
    /**
     * The code of the municipality. Exact match.
     */
    municipalityCode?: string;
}

